import { usePathname } from "next/navigation"

const useShowBorder = () => {
  const pathname = usePathname()
  return ["/about", "/points"].find((fragment) => pathname.includes(fragment))
}

export default useShowBorder
